import { eventAsignmentEnum } from '../../utils/dataStatus';

const filtersAdaptersBase = (filters) => ({
  ubicacion: filters.ubicacion?.length
    ? filters.ubicacion.map((ub) => ({
        value: ub.id,
        label: ub.nombre,
        ...ub
      }))
    : [],
  tipoUbicacionEnum: filters.tipoUbicacionEnum
    ? {
        value: filters.tipoUbicacionEnum.id,
        label: filters.tipoUbicacionEnum.nombre,
        ...filters.tipoUbicacionEnum
      }
    : '',
  unidadesNegocioIds: filters?.unidadesNegocio?.length
    ? filters.unidadesNegocio.map((unidadNegocio) => ({
        value: unidadNegocio.id,
        label: unidadNegocio.nombre,
        ...unidadNegocio
      }))
    : [],
  operacionesIds: filters?.operaciones?.length
    ? filters.operaciones.map((operacion) => ({
        value: operacion.id,
        label: operacion.nombre,
        ...operacion
      }))
    : [],
  idsServicios: filters?.servicios?.length
    ? filters.servicios.map((servicio) => ({
        value: servicio.id,
        label: servicio.nombre,
        ...servicio
      }))
    : [],
  idsProveedores: filters?.proveedores?.length
    ? filters.proveedores.map((proveedor) => ({
        value: proveedor.id,
        label: proveedor.nombre,
        ...proveedor
      }))
    : [],
  idsContratos: filters?.contratos?.length
    ? filters.contratos.map((contrato) => ({
        value: contrato.id,
        label: contrato.nombre,
        ...contrato
      }))
    : [],
  equipo: filters.equipo?.length
    ? filters.equipo.map((equipo) => ({
        value: equipo.id,
        label: equipo.nombre,
        ...equipo
      }))
    : [],
  numeroSolicitud: filters.numeroSolicitud?.length
    ? filters.numeroSolicitud.map((req) => ({
        value: req.id,
        label: req.nombre,
        ...req
      }))
    : [],
  tipoEvento: filters.evento?.length
    ? filters.evento.map((req) => ({
        value: req.id,
        label: req.nombre,
        ...req
      }))
    : []
});

export const approverFiltersAdapterToResponse = (filters) => ({
  ubicacion: filters?.ubicaciones?.length
    ? filters.ubicaciones.map((ub) => ({
        value: ub.id,
        label: ub.nombre,
        ...ub
      }))
    : [],
  tipoUbicacionEnum: filters.tipoUbicacionEnum
    ? {
        value: filters.tipoUbicacionEnum.id,
        label: filters.tipoUbicacionEnum.nombre,
        ...filters.tipoUbicacionEnum
      }
    : '',
  unidadesNegocioIds: filters?.unidadNegocio?.length
    ? filters.unidadNegocio.map((unidadNegocio) => ({
        value: unidadNegocio.id,
        label: unidadNegocio.nombre,
        ...unidadNegocio
      }))
    : [],
  operacionesIds: filters?.operaciones?.length
    ? filters.operaciones.map((operacion) => ({
        value: operacion.id,
        label: operacion.nombre,
        ...operacion
      }))
    : [],
  idsServicios: filters?.servicios?.length
    ? filters.servicios.map((servicio) => ({
        value: servicio.id,
        label: servicio.nombre,
        ...servicio
      }))
    : [],
  idsProveedores: filters?.proveedores?.length
    ? filters.proveedores.map((proveedor) => ({
        value: proveedor.id,
        label: proveedor.nombre,
        ...proveedor
      }))
    : [],
  idsContratos: filters?.contratos?.length
    ? filters.contratos.map((contrato) => ({
        value: contrato.id,
        label: contrato.nombre,
        ...contrato
      }))
    : [],
  equipo: filters?.equipos?.length
    ? filters.equipos.map((equipo) => ({
        value: equipo.id,
        label: equipo.nombre,
        ...equipo
      }))
    : [],
  numeroSolicitud: filters?.numerosSolicitudes?.length
    ? filters.numerosSolicitudes.map((req) => ({
        value: req.id,
        label: req.nombre,
        ...req
      }))
    : [],
  evento: filters?.tipoEvento
    ? filters.tipoEvento.map((req) => ({
        value: req.id,
        label: req.nombre,
        ...req
      }))
    : [],
  posicionesLineas: filters?.posicionesLineas?.length
    ? filters.posicionesLineas.map((posicionLinea) => {
        const nombre = String(`P${posicionLinea}`).replace('-', ' - L');

        return {
          value: posicionLinea,
          label: nombre,
          nombre
        };
      })
    : [],
  estadosSolicitud: filters.estadosSolicitud?.length
    ? filters.estadosSolicitud.map((status) => ({
        id: status.id,
        label: status.nombre,
        ...status
      }))
    : []
});

export const filtersAdapter = (filters) => ({
  ...filtersAdaptersBase(filters),
  numeroSolicitud: filters.numeroSolicitudServicio?.length
    ? filters.numeroSolicitudServicio.map((req) => ({
        value: req.id,
        label: req.nombre,
        ...req
      }))
    : [],
  asignacionEventoEnum: filters?.asignacionEvento || eventAsignmentEnum.all,
  fechaDesde: filters.fechaDesde ?? '',
  fechaHasta: filters.fechaHasta ?? '',
  estadosEnums: filters.estadosEnums.length
    ? filters.estadosEnums.map((item) => ({
        value: item.id,
        id: item.id,
        nombre: item.nombre,
        label: item.nombre
      }))
    : [],
  idEvento: filters.eventos?.length
    ? filters.eventos.map((item) => ({
        value: item.id,
        id: item.id,
        nombre: item.nombre,
        label: item.nombre
      }))
    : [],
  idUsuarioCreador: filters.usuarioCreador
    ? {
        value: filters.usuarioCreador.id,
        label: filters.usuarioCreador.nombre,
        ...filters.usuarioCreador
      }
    : '',
  idPrioridad: filters.prioridad
    ? {
        value: filters.prioridad.id,
        label: filters.prioridad.nombre,
        ...filters.prioridad
      }
    : '',
  equipo: filters.equipoDeTorre?.length
    ? filters.equipoDeTorre.map((item) => ({
        value: item.id,
        id: item.id,
        nombre: item.nombre,
        label: item.nombre
      }))
    : []
});

export const filterRequestAdapter = (filters) => {
  const { posicionesLineas } = filters;

  const labelPositinoLine = posicionesLineas
    ? posicionesLineas?.map((current) => ({
        label: current?.label || `P${current.posicion}-L${current.linea}`,
        nombre: current?.label || `P${current.posicion}-L${current.linea}`,
        posicionId: current?.posicionId,
        posicion: current?.posicion,
        linea: current?.linea,
        lineaId: current?.lineaId,
        position: current?.posicion,
        line: current?.linea
      }))
    : [];

  return filters ? { posicionesLineas: labelPositinoLine } : { posicionesLines: [] };
};

export const filterMSDSRequestAdapter = (filters) => ({ ...filters, haveFilters: true });
